













































































































































































































































import Vue from 'vue'
import { KeyActionEnum, ProductAddressEnum, SnackbarStateEnum } from '@/types/enums'
import {
  DELETE_PRODUCT_ADDRESS, DELETE_PRODUCT_ADDRESS_PRICE,
  FETCH_PRODUCT_ADDRESS_PRICE,
  FETCH_PRODUCT_CUSTOMERS_AND_SUPPLIERS_DATA,
  FETCH_PRODUCT_CUSTOMERS_AND_SUPPLIERS_METADATA,
  UPSERT_PRODUCT_ADDRESS, UPSERT_PRODUCT_ADDRESS_PRICE
} from '@/store/action-types'
import { TranslateResult } from 'vue-i18n'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import {
  DxColumn,
  DxColumnChooser,
  DxDataGrid,
  DxFilterRow,
  DxGrouping,
  DxGroupPanel,
  DxScrolling,
  DxSelection,
  DxSorting,
  DxStateStoring
} from 'devextreme-vue/data-grid'
import { hexToRgba } from '@/services/hex-to-rgba'
import { SearchAddress } from '@/model/addresses/SearchAddress'
import ProjectAddressSearch from '@/components/master-data/address/ProjectAddressSearch.vue'
import {
  ProductAddress,
  ProductAddressPricePayload,
  UpsertProductAddress,
  UpsertProductAddressPricePayload
} from '@/types/payload'
import moment from 'moment'
import { cloneDeep } from 'lodash'
import NumberField from '@/components/NumberField.vue'
import { keyActionService } from '@/services/key-action-service'
import { KeyAction } from '@/model/KeyAction'

class Create extends KeyAction {}
class Edit extends KeyAction {}
class Delete extends KeyAction {}

interface ComponentData {
  tableHeight: string
  isSaveInProgress: boolean
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  addressValid: boolean
  addressDetailValid: boolean
  priceValid: boolean
  validationRules: Array<Function>
  numberRules: Array<Function>
  decimalRules: Array<Function>
  dateRulesNotEmpty: Array<Function>
  dateRules: Array<Function>
  createList: any[]
  context: ProductAddressEnum
  isCreate: boolean
  isUpdate: boolean
  isCreatePrice: boolean
  isUpdatePrice: boolean
  activeTab1: number
  activeTab2: number
  showSearchDialog: boolean
  adressArtList: any[]
  lagerungenList: any[]
  bestelleinheitList: any[]
  waehrungenList: any[]
  einheitenList: any[]
  rabattsaetzeList: any[]
  steuersaetzeList: any[]


  addressId: number | null
  addressLabel: any
  notice: any

  art: any
  lagerung: any
  produktNummer: any
  beschaffungsZeit: number
  beschaffungsMenge: number
  bestellEinheit: any
  losGroesse: number

  preis: number
  waehrung: any
  preiseinheit: any
  einheit: any
  rabatt: any
  steuer: any
  gueltigVonFormatted: any
  gueltigVon: any
  gueltigBisFormatted: any
  gueltigBis: any
  dateFilterFormatted: any
  dateFilter: any

  gridData: any[]
  selectedProductAddress: any | null
  dataGridPrice: any[]
  selectedPrice: any | null

  keyActions: KeyAction[]
}

export default Vue.extend({
  name: 'ProductCustomersAndSuppliers',

  components: {
    DxDataGrid,
    DxColumn,
    DxColumnChooser,
    DxSorting,
    DxFilterRow,
    DxGroupPanel,
    DxGrouping,
    DxScrolling,
    DxSelection,
    DxStateStoring,
    ProjectAddressSearch,
    NumberField
  },

  props: {
    productId: Number,
    selectedProductUnitId: Number
  },

  data (): ComponentData {
    const required = (value: any): boolean | string => !!value || ''
    const numberRule = (value: any): boolean | string => (value >= 0) || ''

    return {
      tableHeight: '',
      isSaveInProgress: false,
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      addressValid: true,
      addressDetailValid: true,
      priceValid: true,
      validationRules: [required],
      numberRules: [numberRule],
      decimalRules: [
        (value: string) => {
          const pattern = /^$|^(\d+(?:[\.\,]\d{1,5})?)$/
          return pattern.test(value) || this.$t('badValue')
        }
      ],
      dateRulesNotEmpty: [
        (value: string) => {
          const pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
          return value && value.length >= 1 ? pattern.test(value) || this.$t('errors.wrongDate').toString() : true
        },

        (value: string) => {
          return value && value.length !== 10 ? this.$t('errors.wrongDate').toString() : true
        },

        required
      ],
      dateRules: [
        (value: string) => {
          const pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
          return value && value.length >= 1 ? pattern.test(value) || this.$t('errors.wrongDate').toString() : true
        },

        (value: string) => {
          return value && value.length !== 10 ? this.$t('errors.wrongDate').toString() : true
        }
      ],
      createList: [
        {id: 1, label: this.$t('product.productCustomersAndSuppliers.createList1')},
        {id: 2, label: this.$t('product.productCustomersAndSuppliers.createList2')}
      ],
      context: ProductAddressEnum.Address,
      isCreate: false,
      isUpdate: false,
      isCreatePrice: false,
      isUpdatePrice: false,
      activeTab1: 0,
      activeTab2: 0,
      showSearchDialog: false,
      adressArtList: [],
      lagerungenList: [],
      bestelleinheitList: [],
      waehrungenList: [],
      einheitenList: [],
      rabattsaetzeList: [],
      steuersaetzeList: [],

      addressId: null,
      addressLabel: null,
      notice: null,

      art: null,
      lagerung: null,
      produktNummer: null,
      beschaffungsZeit: 0,
      beschaffungsMenge: 0.000,
      bestellEinheit: null,
      losGroesse: 0.000,

      preis: 0.000,
      waehrung: null,
      preiseinheit: null,
      einheit: null,
      rabatt: null,
      steuer: null,
      gueltigVonFormatted: null,
      gueltigVon: null,
      gueltigBisFormatted: null,
      gueltigBis: null,
      dateFilterFormatted: null,
      dateFilter: null,

      gridData: [],
      selectedProductAddress: null,
      dataGridPrice: [],
      selectedPrice: null,

      keyActions: []
    }
  },

  watch: {
    productId (newVal: number): void {
      if(newVal && newVal !== 0) {
        this.fetchProductAddressData()
      }
    },

    activeTab2 (newVal: number): void {
      if(newVal === 0) {
        this.isCreatePrice = false
        this.isUpdatePrice = false
        this.context = ProductAddressEnum.Address
      } else if(newVal && newVal === 1) {
        this.isCreate = false
        this.isUpdate = false
        this.context = ProductAddressEnum.Price
        if(!this.isCreatePrice && this.dataGridPrice[0]) {
          this.selectedPrice = this.dataGridPrice[0]
          //@ts-ignore
          setTimeout(() => {this.$refs.dataGridPrice.instance.selectRows([this.dataGridPrice[0].ID])}, 200)
        } else {
          this.resetPriceData()
        }
      }
      setTimeout(() => { this.onResize() }, 500)
    },

    selectedProductAddress (newVal: any): void {
      if (newVal) {
        this.setData()
        this.fetchProductAddressPrice()
      } else {
        this.resetData()
      }
    },

    selectedPrice (newVal: any): void {
      if (newVal) {
        this.setPriceData()
      } else {
        this.resetPriceData()
      }
    },

    gueltigVonFormatted (newVal: string): void {
      if(newVal && newVal.length > 0) {
        this.gueltigVon = moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD')
      } else {
        this.gueltigVon = null
      }
    },

    gueltigBisFormatted (newVal: string): void {
      if(newVal && newVal.length > 0) {
        this.gueltigBis = moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD')
      } else {
        this.gueltigBis = null
      }
    },

    dateFilterFormatted (newVal: string | null): void {
      if(newVal && newVal.length > 0) {
        this.dateFilter = moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD')
      } else {
        this.dateFilter = null
      }
    },

    isCreatePrice (newVal: boolean): void {
      if(newVal) {
        setTimeout(() => {
          const focusedField: any = this.$refs['secondField']
          if (focusedField) {
            focusedField.focus()
          }
        }, 0)
      }
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    selectedLocale (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    getFilteredDataGridPrice (): any[] {
      if(this.dateFilter) {
        return this.dataGridPrice.filter((item: any) => moment(this.dateFilter).isBetween(moment(item.GueltigVon), moment(item.GueltigBis), 'day', '[]'))
      } else {
        return this.dataGridPrice
      }
    }
  },

  methods: {
    onKeydown (event: any): void {
      const action: any = keyActionService(event, this.keyActions)
      action && action.handle()
    },

    resolver (action: Create | Edit | Delete | null): boolean {
      if(action instanceof Create) {
        return true
      } else if(action instanceof Edit) {
        return true
      } else if(action instanceof Delete) {
        return true
      } else {
        return false
      }
    },

    formatNumber(value: number | null, digital: number): any {
      if(value !== null) {
        return new Intl.NumberFormat(navigator && navigator.language ? navigator.language : "de-CH", {
          style: "decimal",
          minimumFractionDigits: digital,
          maximumFractionDigits: digital
        }).format(value)
      } else {
        return ''
      }
    },

    onBeschaffungsZeitChange  (): void {
      if(this.beschaffungsZeit == null || this.beschaffungsZeit < 0) {
        this.beschaffungsZeit = 0
      }
    },

    onBeschaffungsMengeChange  (): void {
      if(this.beschaffungsMenge == null || this.beschaffungsMenge < 0) {
        this.beschaffungsMenge = 0.000
      }
    },

    onLosGroesseChange  (): void {
      if(this.losGroesse == null || this.losGroesse < 0) {
        this.losGroesse = 0.000
      }
    },

    onPreisChange (): void {
      if(this.preis == null || this.preis < 0) {
        this.preis = 0.000
      }
    },

    getProduktBezeichnung (data: any): string {
      const foundItem: any | undefined = this.lagerungenList.find((item: any) => item.ID === data.Lagerung)
      return foundItem ? foundItem.ProduktBezeichnung : ''
    },

    getProduktBeschreibung (data: any): string {
      const foundItem: any | undefined = this.lagerungenList.find((item: any) => item.ID === data.Lagerung)
      return foundItem ? foundItem.Beschreibung : ''
    },

    getAdressArtBezeichnung (data: any): string {
      const foundItem: any | undefined = this.adressArtList.find((item: any) => item.Wert === data.Art)
      return foundItem ? foundItem.Bezeichnung : ''
    },

    getWaehrungBezeichnung (waehrungId: number): string {
      const foundItem: any | undefined = this.waehrungenList.find((item: any) => item.ID === waehrungId)
      return foundItem ? foundItem.Bezeichnung : ''
    },

    getFormattedDate (item: string | null): string {
      return item ? moment(item).format('DD.MM.YYYY') : ''
    },

    onGueltigVonChange (date: string): void {
      if(date && date.length > 0) {
        this.gueltigVonFormatted = moment(date).format('DD.MM.YYYY')
      } else {
        this.gueltigVonFormatted = null
      }
    },

    onGueltigBisChange (date: string): void {
      if(date && date.length > 0) {
        this.gueltigBisFormatted = moment(date).format('DD.MM.YYYY')
      } else {
        this.gueltigBisFormatted = null
      }
    },

    onDateFilterChange (date: string): void {
      if(date && date.length > 0) {
        this.dateFilterFormatted = moment(date).format('DD.MM.YYYY')
      } else {
        this.dateFilterFormatted = null
      }
    },

    create (action?: KeyAction | null): void {
      if (action) {
        action.event.preventDefault()
      }

      setTimeout(() => {
        const menuBtn: any = this.$refs['menuBtn']
        if (menuBtn) {
          menuBtn.$el.focus()
          menuBtn.$el.click()
        }
      }, 0)
    },

    onCreateClick (item: any): void {
      if(item.id === 1) {
        this.activeTab2 = 0
        this.isCreatePrice = false
        this.isUpdatePrice = false
        this.isCreate = true
        this.selectedProductAddress = null
        //@ts-ignore
        this.$refs.dataGrid.instance.selectRows([])
        this.resetData()
        this.context = ProductAddressEnum.Address
        this.showSearchDialog = true
      } else {
        if(this.selectedProductAddress) {
          this.activeTab2 = 1
          this.isCreate = false
          this.isUpdate = false
          this.isCreatePrice = true
          this.selectedPrice = null
          //@ts-ignore
          this.$refs.dataGridPrice.instance.selectRows([])
          this.resetPriceData()
          this.context = ProductAddressEnum.Price
        }
      }
    },

    onUpdateClick (): void {
      this.update()
    },

    update (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      if(this.activeTab2 === 0) {
        if (this.selectedProductAddress) {
          this.isCreate = false
          this.isUpdate = true

          setTimeout(() => {
            const focusedField: any = this.$refs['focusedField']
            if (focusedField) {
              focusedField.focus()
            }
          }, 0)
        }
      } else if(this.activeTab2 === 1) {
        if(this.selectedPrice) {
          this.isCreatePrice = false
          this.isUpdatePrice = true

          setTimeout(() => {
            const focusedField: any = this.$refs['secondField']
            if (focusedField) {
              focusedField.focus()
            }
          }, 0)
        }
      }
    },

    onDeleteClick (): void {
      this.delete()
    },

    delete (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      if(this.context === ProductAddressEnum.Address) {
        if (this.selectedProductAddress && !this.isCreate && !this.isUpdate) {
          this.deleteProductAddress()
        }
      } else if (this.context === ProductAddressEnum.Price) {
        if (this.selectedPrice && !this.isCreatePrice && !this.isUpdatePrice) {
          this.deleteAddressPrice()
        }
      }
    },

    onSearchAddressClick (): void {
      if(this.isCreate || this.isUpdate) {
        this.showSearchDialog = true
      }
    },

    closeSearchDialog (): void {
      this.showSearchDialog = false

      setTimeout(() => {
        const focusedField: any = this.$refs['focusedField']
        if (focusedField) {
          focusedField.focus()
        }
      }, 0)
    },

    onClearAddressClick (): void {
      this.addressLabel = null
      this.addressId = null
    },

    onSelectedAddress (data: SearchAddress): void {
      this.closeSearchDialog()
      this.addressLabel = data.genAdresse
      this.addressId = data.id
    },

    onNoticeLanguagesClick (): void {
    },


    onRowClick (data: any): void {
      this.selectedProductAddress = data.data
    },

    onPriceRowClick (data: any): void {
      this.selectedPrice = data.data
    },

    onCancelClick (): void {
      if(this.context === ProductAddressEnum.Address) {
        this.isCreate = false
        this.isUpdate = false
        if(this.gridData[0]) {
          this.selectedProductAddress = cloneDeep(this.gridData[0])
          //@ts-ignore
          setTimeout(() => {this.$refs.dataGrid.instance.selectRows([this.gridData[0].ID])}, 100)
        } else {
          this.resetData()
        }
      } else if(this.context === ProductAddressEnum.Price) {
        this.isCreatePrice = false
        this.isUpdatePrice = false
        if(this.dataGridPrice) {
          this.selectedPrice = cloneDeep(this.dataGridPrice[0])
          //@ts-ignore
          setTimeout(() => {this.$refs.dataGridPrice.instance.selectRows([this.dataGridPrice[0].ID])}, 100)
        } else {
          this.resetData()
        }
      }
    },


    onSaveClick (): void {
      if(this.context === ProductAddressEnum.Address) {
        this.upsertProductAddress()
      } else if(this.context === ProductAddressEnum.Price) {
        this.upsertAddressPrice()
      }
    },

    async upsertProductAddress (): Promise<void> {
      const form1: any = this.$refs['formAddress']
      const form2: any = this.$refs['formAddressDetail']

      if(form1.validate() && form2.validate()) {

        const payloadData: ProductAddress = {
          ID: this.selectedProductAddress ? this.selectedProductAddress.ID : 0,
          Adresse: this.selectedProductAddress ? this.selectedProductAddress.Adresse : this.addressId!,
          Produkt: this.productId,
          ProduktNummer: this.produktNummer ? this.produktNummer : '',
          PunkteMinimal: 0,
          PunkteMaximal: 0,
          PunkteAktuell: 0,
          Richtung: 0,
          BeschaffungsZeit: this.beschaffungsZeit,
          BeschaffungsMenge: this.beschaffungsMenge,  //double
          Art: this.art,
          LosGroesse: this.losGroesse,  //double
          Lagerung: this.lagerung,
          BestellEinheit: this.bestellEinheit
        }
        const payload: UpsertProductAddress = {
          Data: {
            Adresse: payloadData
          }
        }

        try {
          this.isSaveInProgress = true
          const response: any = await this.$store.dispatch(UPSERT_PRODUCT_ADDRESS, payload)
          if (!response.IsError) {
            this.isCreate = false
            this.isUpdate = false
            const createdAddressId: number | null = response.Data && response.Data.Produkte_UpsertProduktAdresse && response.Data.Produkte_UpsertProduktAdresse.ID ? response.Data.Produkte_UpsertProduktAdresse.ID : null
            this.fetchProductAddressData(createdAddressId)
            this.messageSnackbar = response.Result ? response.Result : this.$t('success.dataHaveBeenSaved').toString()
            this.snackbarState = SnackbarStateEnum.Success
          } else {
            this.messageSnackbar = response.Result ? response.Result : this.$t('errors.dataCouldNotBeSaved').toString()
            this.snackbarState = SnackbarStateEnum.Error
          }
        } catch {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved').toString()
          this.snackbarState = SnackbarStateEnum.Error
        } finally {
          this.showSnackbar = true
          this.isSaveInProgress = false
        }
      }
    },

    async deleteProductAddress (): Promise<void> {
      try {
        //this.loading = true
        const response: any = await this.$store.dispatch(DELETE_PRODUCT_ADDRESS, this.selectedProductAddress.ID)
        if(!response.IsError) {
          this.fetchProductAddressData()
          this.messageSnackbar = response.Result ? response.Result : this.$t('success.dataHaveBeenDeleted').toString()
          this.snackbarState = SnackbarStateEnum.Success
        } else {
          this.messageSnackbar =  response.Result ? response.Result : this.$t('errors.dataCouldNotBeDeleted')
          this.snackbarState = SnackbarStateEnum.Error
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
        this.snackbarState = SnackbarStateEnum.Error
      } finally {
        this.showSnackbar = true
        //this.loading = false
      }
    },

    async upsertAddressPrice (): Promise<void> {
      const form: any = this.$refs['formPrice']

      if(form.validate()) {
        const payloadData: ProductAddressPricePayload = {
          ID: this.selectedPrice ? this.selectedPrice.ID : 0,
          ProduktAdresse: this.selectedProductAddress.ID,
          Preis: this.preis,
          Preiseinheit: this.preiseinheit ? parseInt(this.preiseinheit) : 1,
          Einheit: this.einheit,
          Waehrung: this.waehrung,
          Rabatt: this.rabatt,
          Steuer: this.steuer,
          GueltigVon: this.gueltigVon,
          GueltigBis: this.gueltigBis
        }
        const payload: UpsertProductAddressPricePayload = {
          Data: {
            ProduktAdressePreise: payloadData
          }
        }

        try {
          this.isSaveInProgress = true
          const response: any = await this.$store.dispatch(UPSERT_PRODUCT_ADDRESS_PRICE, payload)
          if (!response.IsError) {
            this.isCreatePrice = false
            this.isUpdatePrice = false
            const createdPriceId: number | null = response.Data && response.Data.Produkte_UpsertProduktAdressenPreise && response.Data.Produkte_UpsertProduktAdressenPreise.ID ? response.Data.Produkte_UpsertProduktAdressenPreise.ID : null
            this.fetchProductAddressPrice(createdPriceId)
            this.messageSnackbar = response.Result ? response.Result : this.$t('success.dataHaveBeenSaved').toString()
            this.snackbarState = SnackbarStateEnum.Success
          } else {
            this.messageSnackbar = response.Result ? response.Result : this.$t('errors.dataCouldNotBeSaved').toString()
            this.snackbarState = SnackbarStateEnum.Error
          }
        } catch {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved').toString()
          this.snackbarState = SnackbarStateEnum.Error
        } finally {
          this.showSnackbar = true
          this.isSaveInProgress = false
        }
      }
    },

    async deleteAddressPrice (): Promise<void> {
      try {
        //this.loading = true
        const response: any = await this.$store.dispatch(DELETE_PRODUCT_ADDRESS_PRICE, this.selectedPrice.ID)
        if(!response.IsError) {
          this.fetchProductAddressPrice()
          this.messageSnackbar = response.Result ? response.Result : this.$t('success.dataHaveBeenDeleted').toString()
          this.snackbarState = SnackbarStateEnum.Success
        } else {
          this.messageSnackbar =  response.Result ? response.Result : this.$t('errors.dataCouldNotBeDeleted')
          this.snackbarState = SnackbarStateEnum.Error
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
        this.snackbarState = SnackbarStateEnum.Error
      } finally {
        this.showSnackbar = true
        //this.loading = false
      }
    },

    setData (): void {
      this.addressLabel = this.selectedProductAddress ? this.selectedProductAddress.GenAdresse : null
      this.art = this.selectedProductAddress ? this.selectedProductAddress.Art : null
      this.lagerung = this.selectedProductAddress ? this.selectedProductAddress.Lagerung : null
      this.produktNummer = this.selectedProductAddress ? this.selectedProductAddress.ProduktNummer : null
      this.beschaffungsZeit = this.selectedProductAddress ? this.selectedProductAddress.BeschaffungsZeit : 0
      this.beschaffungsMenge = this.selectedProductAddress && this.selectedProductAddress.BeschaffungsMenge >= 0.000 ? parseFloat(this.selectedProductAddress.BeschaffungsMenge.toFixed(3)) : 0.000
      this.bestellEinheit = this.selectedProductAddress ? this.selectedProductAddress.BestellEinheit : null
      this.losGroesse = this.selectedProductAddress && this.selectedProductAddress.LosGroesse >= 0.000 ? parseFloat(this.selectedProductAddress.LosGroesse.toFixed(3)) : 0.000
    },

    resetData (): void {
      this.addressLabel = null
      this.selectedPrice = null
      this.art = null
      this.lagerung = null
      this.produktNummer = null
      this.beschaffungsZeit = 0
      this.beschaffungsMenge = 0
      this.bestellEinheit = this.selectedProductUnitId ? this.selectedProductUnitId : null
      this.losGroesse = 0
      const form1: any = this.$refs['formAddress']
      const form2: any = this.$refs['formAddressDetail']
      form1.resetValidation()
      form2.resetValidation()
    },

    setPriceData (): void {
      this.preis = this.selectedPrice && this.selectedPrice.Preis >= 0.000 ?  parseFloat(this.selectedPrice.Preis.toFixed(3)) : 0.000
      this.waehrung = this.selectedPrice ? this.selectedPrice.Waehrung : null
      this.preiseinheit = this.selectedPrice ? this.selectedPrice.Preiseinheit : null
      this.einheit = this.selectedPrice ? this.selectedPrice.Einheit : null
      this.rabatt = this.selectedPrice ? this.selectedPrice.Rabatt : null
      this.steuer = this.selectedPrice ? this.selectedPrice.Steuer : null
      this.gueltigVonFormatted = this.selectedPrice && this.selectedPrice.GueltigVon ? moment(this.selectedPrice.GueltigVon).format('DD.MM.YYYY') : null
      this.gueltigVon = this.selectedPrice ? this.selectedPrice.GueltigVon : null
      this.gueltigBisFormatted = this.selectedPrice && this.selectedPrice.GueltigBis ? moment(this.selectedPrice.GueltigBis).format('DD.MM.YYYY') : null
      this.gueltigBis = this.selectedPrice ? this.selectedPrice.GueltigBis : null
    },

    resetPriceData (): void {
      if(this.isCreatePrice) {
        this.preis = 0.000
        this.waehrung = this.waehrungenList && this.waehrungenList[0] ? this.waehrungenList[0].ID : null
        this.preiseinheit = 1
        this.einheit = this.selectedProductUnitId ? this.selectedProductUnitId : null
        this.rabatt = null //this.rabattsaetzeList && this.rabattsaetzeList[0] ? this.rabattsaetzeList[0].ID : null
        this.steuer = null //this.steuersaetzeList && this.steuersaetzeList[0] ? this.steuersaetzeList[0].ID : null
        this.gueltigVonFormatted = moment().format('DD.MM.YYYY')
        this.gueltigVon = moment().format('YYYY-MM-DD')
        this.gueltigBisFormatted = moment().format('DD.MM.YYYY')
        this.gueltigBis = moment().format('YYYY-MM-DD')
      } else {
        this.preis = 0.000
        this.waehrung = null
        this.preiseinheit = null
        this.einheit = null
        this.rabatt = null
        this.steuer = null
        this.gueltigVonFormatted = null
        this.gueltigVon = null
        this.gueltigBisFormatted = null
        this.gueltigBis = null
        this.dateFilterFormatted = null
        this.dateFilter = null
      }

      const form: any = this.$refs['formPrice']
      if(form) {
        form.resetValidation()
      }
    },

    async fetchProductAddressPrice (createdPriceId?: number | null): Promise<void> {
      try {
        const response: any = await this.$store.dispatch(FETCH_PRODUCT_ADDRESS_PRICE, this.selectedProductAddress.ID)
        if(!response.IsError && response.Data) {
          this.dataGridPrice = response.Data
          let foundPrice: any | undefined = undefined
          if(createdPriceId) {
            foundPrice = this.dataGridPrice.find((item: any) => item.ID === createdPriceId)
          }

          if(foundPrice) {
            this.selectedPrice = foundPrice ? foundPrice : null
            if(this.activeTab2 === 1) {
              //@ts-ignore
              setTimeout(() => {this.$refs.dataGridPrice.instance.selectRows([foundPrice.ID])}, 100)
            }
          } else if(this.dataGridPrice[0]) {
            this.selectedPrice = this.dataGridPrice[0]
            if(this.activeTab2 === 1) {
              //@ts-ignore
              setTimeout(() => {this.$refs.dataGridPrice.instance.selectRows([this.dataGridPrice[0].ID])}, 100)
            }
          } else {
            this.selectedPrice = null
          }
        } else {
          this.messageSnackbar =  response.Result ? response.Result : this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async fetchProductAddressData (createdAddressId?: number | null): Promise<void> {
      try {
        const response: any = await this.$store.dispatch(FETCH_PRODUCT_CUSTOMERS_AND_SUPPLIERS_DATA, this.productId)
        if(!response.IsError && response.Data) {
          this.gridData = response.Data.ProduktAdresse
          this.lagerungenList = response.Data.Lagerungen
          let foundAddress: any | undefined = undefined
          if(createdAddressId) {
            foundAddress = this.gridData.find((item: any) => item.ID === createdAddressId)
          }

          if(foundAddress) {
            this.selectedProductAddress = foundAddress ? foundAddress : null
            //@ts-ignore
            setTimeout(() => {this.$refs.dataGrid.instance.selectRows([foundAddress.ID])}, 100)
          } else if(this.gridData[0]) {
            this.selectedProductAddress = this.gridData[0]
            //@ts-ignore
            setTimeout(() => {this.$refs.dataGrid.instance.selectRows([this.gridData[0].ID])}, 100)
          } else {
            this.selectedProductAddress = null
          }
        } else {
          this.messageSnackbar =  response.Result ? response.Result : this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async fetchProductAddressMetadata (): Promise<void> {
      try {
        const response: any = await this.$store.dispatch(FETCH_PRODUCT_CUSTOMERS_AND_SUPPLIERS_METADATA)
        if(!response.IsError && response.Data) {
          this.adressArtList = response.Data.PRAART
          this.bestelleinheitList = response.Data.Einheiten
          this.waehrungenList= response.Data.Waehrungen
          this.einheitenList= response.Data.Einheiten
          this.rabattsaetzeList= response.Data.Rabattsaetze
          this.steuersaetzeList= response.Data.Steuersaetze

        } else {
          this.messageSnackbar =  response.Result ? response.Result : this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    onResize (): void {
      if(this.$refs.formSection && this.$vuetify.breakpoint.mdAndUp) {
        const vh = window.innerHeight
        if(vh > 1070) {
          const height = (this.$refs.formSection as HTMLElement).clientHeight
          this.tableHeight = `height: calc(${vh}px - 312px - ${height}px)`
        } else {
          this.tableHeight = 'height: 350px'
        }
      } else {
        this.tableHeight = 'height: 350px'
      }
    },
  },

  beforeMount () {
    this.keyActions = [
      new Create(KeyActionEnum.create, this.create, this.resolver,  null),
      new Edit(KeyActionEnum.edit, this.update, this.resolver, null),
      new Delete(KeyActionEnum.delete, this.delete, this.resolver, null),
    ]
  },

  mounted() {
    window.addEventListener('keydown', this.onKeydown)
    setTimeout(() => { this.onResize() }, 0)
    this.fetchProductAddressData()
    this.fetchProductAddressMetadata()
  },

  beforeDestroy (): void {
    window.removeEventListener('keydown', this.onKeydown)
  }
})
